import React, { useCallback, useEffect, useState } from 'react'
import { BOGO_EXPLAINER_MODAL_SHOULD_BE_SHOWN } from '@mc/constants'
import { trackBogoPromoModalViewed } from '@mc/pre-paywall-events'
import { Actions, Locations } from '@mc/track-event'
import { useUserInteractions } from '@mc/visibility'
import { trackNavigationClicked, trackOfferViewed } from '../../utils/events'
import { useShouldShowBogoPromoModal } from '../../utils/useShouldShowBogoPromoModal'
import { BogoPromoModalContent } from './BogoPromoModalContent'
import { isBogoPromoModalDismissed } from './isBogoPromoModalDismissed'

export const BogoPromoModal = () => {
  const [show, setShow] = useState(false)
  const { shouldShowBogoPromoModal } = useShouldShowBogoPromoModal()

  const setActions = useCallback(() => {
    /* Full set of conditions for showing bogo modal:
     * - User has not clicked anywhere in the page
     * - 6 seconds have passed since page load
     * - User has already scrolled
     * - User has not dismissed a discount modal recently or if they did,
     * they no longer have a promo code
     * - The user has already dismissed the modal by clicking the close button
     */

    if (shouldShowBogoPromoModal) {
      setShow(true)
      trackOfferViewed('offer_modal')
      trackBogoPromoModalViewed()
    }
  }, [shouldShowBogoPromoModal])

  useEffect(() => {
    /*
     * in order to avoid collision with other modals, it is set this key to
     * let know other modals about the chance of the modal being shown.
     */
    window.sessionStorage.setItem(
      BOGO_EXPLAINER_MODAL_SHOULD_BE_SHOWN,
      shouldShowBogoPromoModal?.toString() ?? '',
    )
  }, [shouldShowBogoPromoModal])

  useUserInteractions({
    timedActions: setActions,
    enableConditionFn: isBogoPromoModalDismissed,
  })

  const closeModal = () => {
    setShow(false)
    trackNavigationClicked({
      location: Locations.PROMOTION_MODAL,
      action: Actions.CLOSE,
    })
  }

  if (!show) return null

  return (
    <BogoPromoModalContent
      show={show}
      closeModal={closeModal}
      setShow={setShow}
    />
  )
}
